import { axios } from "../../lib/axios";

export const DeleteConsultant = (TeamId: string) => {
    return axios.delete(`/consultant/${TeamId}`)
        .then(response => response.data);
};